import { Button } from "@/components/ui/button";
import { CheckIcon, CopyIcon } from "lucide-react";
import { type ReactNode } from "react";

type InlineCopyValueProps = {
  value: ReactNode;
  copyValue: string;
  copiedValue: string | null;
  onCopy: (value: string) => void;
};

/**
 * Inline value with a small clipboard button beside it. Used for copyable
 * identity fields (siren, siret, tva) inside grids or rows where adding the
 * full `CopyableField` chrome (icon wrapper, label) would be too heavy.
 */
export default function InlineCopyValue({
  value,
  copyValue,
  copiedValue,
  onCopy,
}: InlineCopyValueProps) {
  const isCopied = copiedValue === copyValue;
  return (
    <span className="inline-flex items-center gap-1 min-w-0">
      <span className="truncate">{value}</span>
      <Button
        variant="ghost"
        size="icon"
        className="w-6 h-6 shrink-0"
        onClick={() => onCopy(copyValue)}
      >
        {isCopied ? (
          <CheckIcon className="w-3 h-3 text-emerald-500" />
        ) : (
          <CopyIcon className="w-3 h-3 text-muted-foreground" />
        )}
      </Button>
    </span>
  );
}
